import createIcon from '../../createIcon';

/**
 * @component @name Desk
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA2VjE4SDRWOEgxNFYxOEgxNlYxNkgyMFYxOEgyMlY2SDJaTTIwIDhWMTBIMTZWOEgyMFpNMTYgMTRWMTJIMjBWMTRIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Desk = createIcon('Desk', [
  [
    'path',
    {
      d: 'M2 6V18H4V8H14V18H16V16H20V18H22V6H2ZM20 8V10H16V8H20ZM16 14V12H20V14H16Z',
      key: 'n7ehp2',
    },
  ],
]);

export default Desk;
